import React from "react";
import { boundError } from "../utils";

const MessagesRaw = () => {
  return <div>Messages</div>;
};

export const Messages = boundError(MessagesRaw);
